var _line, _line2, _line3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendmailnoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 140,
    viewBox: "0 0 255 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.2891,
    y1: 40,
    x2: 102.289,
    y2: 40,
    stroke: "#00DFA2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.28906,
    y1: 70,
    x2: 102.289,
    y2: 70,
    stroke: "#00DFA2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 27.2891,
    y1: 100,
    x2: 102.289,
    y2: 100,
    stroke: "#00DFA2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2233_7880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.284 18.667H122.294C118.149 18.667 114.789 21.803 114.789 25.6715V116.663C114.789 120.531 118.149 123.667 122.294 123.667H247.284C251.429 123.667 254.789 120.531 254.789 116.663V25.6715C254.789 21.803 251.429 18.667 247.284 18.667ZM246.513 23.3335L185.048 80.7008L123.583 23.3335H246.513ZM119.789 115.544V26.4764L167.504 71.0103L119.789 115.544ZM123.583 119.001L171.298 74.3882L183.28 85.5329C183.769 85.9887 184.408 86.1967 185.048 86.1967C185.687 86.1967 186.327 85.9591 186.815 85.5036L198.798 74.3926L246.514 119.001H123.583ZM249.789 115.543L202.075 71.0098L249.789 26.4764V115.543Z",
    fill: "#00DFA2",
    stroke: "#00DFA2",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2233_7880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white",
    transform: "translate(114.789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendmailnoti);
export default __webpack_public_path__ + "static/media/sendmailnoti.7df20104bc59cf01ee96893418e91f52.svg";
export { ForwardRef as ReactComponent };